import React from "react";
import classNames from "classnames";
import { NavLink, useLocation } from "react-router-dom";
import { getCurrentCulture } from "@utils";

type PlayerInfoCenterItem = {
	path: string;
	translation: string;
};
export default function PlayerInfoCenterItem(props: PlayerInfoCenterItem) {
	const { path, translation } = props;

	const pathLocation = useLocation();

	return (
		<li className="nav--secondary__item nav--account__item">
			<NavLink
				to={path}
				className="nav--secondary__link"
				activeClassName="is-selected"
				isActive={(match, location) => location.pathname.includes(path)}
				title={translation}
			>
				<i
					className={classNames(
						"nav--secondary__icon u-icon u-icon--big",
						{
							"u-icon--user-info--alt":
								!pathLocation.pathname.includes(
									`player-information-center`
								),
							"u-icon--user-info--bold u-color--core--snow":
								pathLocation.pathname.includes(
									`player-information-center`
								),
						}
					)}
				/>
				<div
					className={classNames("nav--secondary__title", {
						"is-long":
							translation?.length > 11 &&
							(getCurrentCulture() == "sv" ||
								getCurrentCulture() == "da"),
					})}
				>
					{translation}
				</div>
			</NavLink>
		</li>
	);
}
